import { StoreConfig } from "@ngrx/store";

export class Lead_New {
    _id: string;
    id: string;
    name: string;
    phone: string;
    email: string;
    location: string;
    address: string;
    socialmedia: string;
    lat: string;
    lng: string;

    source: {
        _id: string;
        id: string;
    }
    contact_id: {
        _id: string;
        id: string;
        name: string;
        email: string;
        phone: string;
        socialmedia: {_id:string,id:string};
        landmark:
        { type: 'Point',address:string, coordinates: any[] };
        location: string;
    };
    title: string;
    type: {
        _id: string
        id: string
        displayname: string
    };
    type_id: {
        qualification: string;
        coursecatinterest_id: {
            _id: string
            id: string
        };
        college_id: {
            _id: string
            id: string
        };
        skillsinterst_id:[
            {
                _id: string
                id: string
            }
        ]    
    };
    platform: string;
    lead_status: {
        _id: string
        id: string
        displayname: string
    };
    lead_stage: {
        displayname: string
        _id: string
        id: string
    };
    last_activedate: string;
    lastresponse: string;
    ip: string;
    next_action: {
        _id: string
        id: string
        displayname: string
    };
    task_ids: string;
    last_activated: string;
    notes: string;
    admin_notes: string;
}
